import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider.tsx";

export interface CustomNumberFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    value: string | undefined;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomNumberField(props: CustomNumberFieldProps) {
    const { translateString } = useTranslation();
    const { language } = useUserContext();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    return (
        <DotLegalTextField
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            label={props.fieldName!}
            toolTipText={props.fieldDescription}
            value={props.value ? String(props.value) : ""}
            onlyNumber={"decimal"}
            debounce={!props.readOnly}
            onChange={props.readOnly ? () => {} : (val) => onFieldChange(val ? parseFloat(val) : null)}
            disabled={props.isDisabled}
            seperatorStyle={language === "en" ? "en" : "da"}
            errorText={props.errorText}
            helperText={props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.NumberField].toString())) : undefined}
        />
    );
}

export default CustomNumberField;
